import { render, staticRenderFns } from "./DataStatistics.vue?vue&type=template&id=827f8e16&scoped=true"
import script from "./DataStatistics.vue?vue&type=script&lang=js"
export * from "./DataStatistics.vue?vue&type=script&lang=js"
import style0 from "./DataStatistics.vue?vue&type=style&index=0&id=827f8e16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827f8e16",
  null
  
)

component.options.__file = "DataStatistics.vue"
export default component.exports